module.exports = __webpack_public_path__ + "img/sptg.b67db22f.png";